const browser = navigator.userAgent.toLocaleLowerCase();

System.import(
	/* webpackChunkName: "core/vendor/svg4everybody/svg4everybody@2.1.9" */
	'@core/vendor/svg4everybody/svg4everybody@2.1.9'
)
.then((svg4everybody) => {
	svg4everybody();
});



// WEBPACK FOOTER //
// ./client/src/core/polyfills/svg4everybody/async-load__svg4everybody.js